import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "status"]
  static values = { seconds: Number }

  connect() {
    this.remaining = Math.max(0, Math.ceil(this.secondsValue))
    this.render()

    if (this.remaining > 0) {
      this.statusTarget.textContent = `Podrás reenviar el código en ${this.remaining} segundos.`
      this.interval = setInterval(() => this.tick(), 1000)
    }
  }

  disconnect() {
    clearInterval(this.interval)
  }

  tick() {
    this.remaining -= 1
    this.render()

    if (this.remaining <= 0) {
      clearInterval(this.interval)
      this.statusTarget.textContent = "Ya puedes reenviar el código."
    }
  }

  render() {
    const waiting = this.remaining > 0
    this.buttonTarget.disabled = waiting
    this.buttonTarget.textContent = waiting
      ? `Reenviar en ${this.format(this.remaining)}`
      : "Reenviar código"
  }

  format(seconds) {
    return `${String(Math.floor(seconds / 60)).padStart(2, "0")}:${String(seconds % 60).padStart(2, "0")}`
  }
}
